/** `data` of a `contract_family_summary` v1 envelope: how a family summary cell was consolidated. */
export interface ContractFamilySummary {
  consolidationApproach: string;
  documentsApplied: { documentName: string; effect: string }[];
  consolidationActions: string;
  exclusionsOrUncertainties: { documentOrIssue: string; reason: string }[];
}

const text = (value: unknown): string => (typeof value === "string" ? value.trim() : "");

const records = (value: unknown): Record<string, unknown>[] =>
  Array.isArray(value)
    ? value.filter((item): item is Record<string, unknown> => typeof item === "object" && item !== null)
    : [];

/**
 * The payload is model output relayed by the backend, so every field is read defensively: a missing
 * or mistyped one becomes empty rather than breaking the drawer.
 */
export const parseContractFamilySummary = (data: Record<string, unknown>): ContractFamilySummary => ({
  consolidationApproach: text(data.consolidation_approach),
  documentsApplied: records(data.documents_applied)
    .map(item => ({ documentName: text(item.document_name), effect: text(item.effect) }))
    .filter(item => item.documentName),
  consolidationActions: text(data.consolidation_actions),
  exclusionsOrUncertainties: records(data.material_exclusions_or_uncertainties)
    .map(item => ({ documentOrIssue: text(item.document_or_issue), reason: text(item.reason) }))
    .filter(item => item.documentOrIssue),
});

export const hasContractFamilySummaryContent = (summary: ContractFamilySummary): boolean =>
  Boolean(
    summary.consolidationApproach ||
    summary.consolidationActions ||
    summary.documentsApplied.length ||
    summary.exclusionsOrUncertainties.length,
  );
